<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-single element-type-prologue element-with-heading" id="prologue">
<div class="heading heading-with-title heading-without-image" id="prologue-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Prologue</h1>
</div>
</div>
</div>
</div>
<div class="text" id="prologue-text">
<p class="first first-in-chapter first-full-width"><span class="drop-cap">H</span>e was almost numb to the pain now, his mind and his body both spent. There was the unmistakable metallic taste of blood on his tongue. It coated his mouth, filled his throat. He swallowed, no longer able to muster the strength to spit the thick liquid out. Seconds later more blood was already pooling.</p>
<p class="subsq">The skin on his face was stiff from the dried blood caked on his cheeks, but more blood was still fresh, coming from his nose, which must be broken he thought, and from the gash above his eye. His head throbbed and with each pulse a new wave of liquid oozed down his face.</p>
<p class="subsq">He remained upright, but only because of the two men holding him. Without their support, he surely wouldn’t be able to stand.</p>
<p class="subsq">They shoved him another step forward, closer to the edge, their grips like industrial vices. Both men were tall. Taller than he was, and heftier too. Despite this, he wanted desperately to fight back, wanted to hurt them. Yet his body wouldn’t allow it. His head and mind felt disconnected from the rest of him.</p>
<p class="subsq">His thoughts wandered. He tried to remember how he’d come to be <i>here</i>.</p>
<p class="subsq">Of course, he knew the answer in a physical sense – out on the balcony on the top floor of the apartment block. The two men had dragged him out, each one wrenching an arm firmly behind his back, twisting his wrists so that his elbows, his shoulders, were at breaking point.</p>
<p class="subsq">What he struggled to answer was how his life had brought him to this point. When did it all go so wrong?</p>
<p class="subsq">Throughout the ordeal, the two men hadn’t spoken a word to him. But then they hadn’t needed to.</p>
<p class="subsq">He knew why <i>they</i> were there.</p>
<p class="subsq">Another step and they reached the balcony edge. His head dangled forward and he could see the outline of the thick concrete slabs far below. The blood stopped pooling in his mouth, the droplets instead spilling into the emptiness beneath him. He felt a chilling wind against his face.</p>
<p class="subsq">He blinked, then opened his eyes wide. Thought he saw the ground moving – coming toward him, it seemed.</p>
<p class="subsq">He thought again, <i>How did I get here?</i></p>
<p class="subsq">And then he thought about <i>her</i>.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// prologue.vue?555b09d3